// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    //R2
    production: true,
    baseAuthAPIUrl: 'https://auth.r2.rpost.net',
    azureSSOClientId: 'feebd1bf-fca0-4e38-8ab9-896cbcc5946f',
    scopeId: 'deba313c-7939-465c-babe-4c4f29a771dd',
    googleSSOClientId: '733799545702-6181gbtttdl84g8k6uj792mfqu1ukuho.apps.googleusercontent.com',
    googleProvider: 'Google',
    azureADProvider: 'AzureAD',
    rcapClientId: '89278687-d54e-4321-81af-9e0d5f2f8cda',
    baseWebAPIUrl: 'https://webapi.r2.rpost.net',
    maxAzureLoginRetries: 5,
    maxAzureLoginWithSelectRetries: 2,
    maxAzureLoginDelay: 4000,
    enableAddPerformanceLogging: false,
    azureLoginRedirectURI: '/loginredirect/',
    rsignClientId: '999F091E-3888-4F18-BA89-C211A8D16A75' //prod rsign client id

  //staging
  // production: false,
  // baseAuthAPIUrl: 'https://auth.s1.rpost.info',
  // azureSSOClientId: '89278687-d54e-4321-81af-9e0d5f2f8cda',
  // scopeId: '8f491afb-add0-4cd4-82a5-f9e477d6a057',
  // googleSSOClientId: '862880168137-ldp2epm5rbc82hfbabcjmbhipiutcboe.apps.googleusercontent.com',
  // googleProvider: 'Google',
  // azureADProvider: 'AzureAD',
  // rcapClientId: '89278687-d54e-4321-81af-9e0d5f2f8cda',
  // baseWebAPIUrl: 'https://webapi.s1.rpost.info',
  // maxAzureLoginRetries: 5,
  // maxAzureLoginWithSelectRetries: 2,
  // maxAzureLoginDelay: 4000,
  // enableAddPerformanceLogging: false,
  // azureLoginRedirectURI:'/loginredirect/',
  // rsignClientId:'EBC45D19-C8A7-4956-B661-2D6F76616309' //Staging Rsign client id

  //QA
    // production: false,
    // baseAuthAPIUrl: 'https://auth.qa.rpost.net',
    // azureSSOClientId: '89278687-d54e-4321-81af-9e0d5f2f8cda',
    // scopeId: '8f491afb-add0-4cd4-82a5-f9e477d6a057',
    // googleSSOClientId: '862880168137-ldp2epm5rbc82hfbabcjmbhipiutcboe.apps.googleusercontent.com',
    // googleProvider: 'Google',
    // azureADProvider: 'AzureAD',
    // rcapClientId: '89278687-d54e-4321-81af-9e0d5f2f8cda',
    // baseWebAPIUrl: 'https://webapi.qa.rpost.net',
    // maxAzureLoginRetries: 5,
    // maxAzureLoginWithSelectRetries: 2,
    // maxAzureLoginDelay: 4000,
    // enableAddPerformanceLogging: false,
    // azureLoginRedirectURI: '/loginredirect/',
    // rsignClientId: 'EBC45D19-C8A7-4956-B661-2D6F76616309'

    //R1
    // production: true,
    // baseAuthAPIUrl: 'https://auth.r1.rpost.net',
    // azureSSOClientId: 'a58f8234-f671-4320-b595-68299fcab383',
    // scopeId: '3a59807d-8410-405e-988e-adde4c2fe96f',
    // googleSSOClientId: '27038867997-6073okjaag34jfgg5nu2uau867aa4rbf.apps.googleusercontent.com',
    // googleProvider: 'Google',
    // azureADProvider: 'AzureAD',
    // rcapClientId: '89278687-d54e-4321-81af-9e0d5f2f8cda',
    // baseWebAPIUrl: 'https://webapi.r1.rpost.net',
    // maxAzureLoginRetries: 5,
    // maxAzureLoginWithSelectRetries: 2,
    // maxAzureLoginDelay: 4000,
    // enableAddPerformanceLogging: false,
    // azureLoginRedirectURI: '/loginredirect/',
    // rsignClientId: '999F091E-3888-4F18-BA89-C211A8D16A75' //prod rsign client id
};
/*
maxAzureLoginRetries - Max number of times popup will be presented
maxAzureLoginWithSelectRetries - Max number when prompt will be select out of maxAzureLoginRetries. 2 out of 5 will be with select
maxAzureLoginDelay: delay between each popup call
enableAddPerformanceLogging : true for enabling AddPerformanceLogging method call, false for skipping AddPerformanceLogging method call
*/

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
